<template>
    <base-modal title="Seminar bearbeiten">
        <seminar-form ref="seminarForm" :seminar="seminar" @saved="handleSeminarSaved" />

        <template #footer>
            <panel>
                <btn theme="secondary" label="Abbrechen" @click="$emit('close')"/>
                <btn theme="success" label="Speichern" @click="triggerSaveSeminar"/>
            </panel>
        </template>
    </base-modal>
</template>

<script>
    export default {
        props: {
            seminar: {type: Object, required: true},
        },

        methods: {
            async handleSeminarSaved(seminar) {
                let data = await this.$store.dispatch('backend/updateSeminar', {id_seminar: this.seminar.id_seminar, seminar});
                if (data.$success) {
                    this.$emit('close');
                }
            },

            triggerSaveSeminar() {
                this.$refs.seminarForm.submitForm();
            },
        },
    };
</script>